import React, { Component } from "react";

import HeroContainer from './BBPage/HeroContainer';
import HistoryContainer from './BBPage/HistoryContainer';
import WhatIsBBContainer from './BBPage/WhatIsBBContainer';
import RangeContainer from './BBPage/RangeContainer';
import PorcelainIntroContainer from './BBPage/PorcelainIntroContainer';
import WhatIsPGContainer from './BBPage/WhatIsPGContainer';

class BBCreamContainer extends Component {
	render() {
		return (
			<div className="bb">
				<HeroContainer />
				<HistoryContainer />
				<RangeContainer />
				<PorcelainIntroContainer />
				<WhatIsPGContainer />
			</div>
		)
	}
}

export default BBCreamContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/BBCreamContainer.jsx
 **/